import { Navigate } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * ProtectedRoute component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render
 * @param {string} [props.privilege] - Single privilege required
 * @param {string[]} [props.anyOf] - Array of privileges - user needs at least ONE of these
 */
export default function ProtectedRoute({ children, privilege, anyOf }) {
    const { admin, isLoading, hasPrivilege } = useAdmin();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <LoadingSpinner size="large" />
            </div>
        );
    }

    if (!admin) {
        return <Navigate to="/unauthorized" replace />;
    }

    // If single privilege is specified, check if admin has it
    if (privilege && !hasPrivilege(privilege)) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen">
                <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
                <p className="text-muted-light dark:text-muted-dark">
                    You don't have permission to access this page.
                </p>
            </div>
        );
    }

    // If anyOf is specified, check if admin has at least one of the privileges
    if (anyOf && anyOf.length > 0) {
        const hasAny = anyOf.some(p => hasPrivilege(p));
        if (!hasAny) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen">
                    <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
                    <p className="text-muted-light dark:text-muted-dark">
                        You don't have permission to access this page.
                    </p>
                </div>
            );
        }
    }

    return children;
}

